var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('Alert',{attrs:{"type":"error","title":"Failed to Retrieve Data"}},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }